import './bootstrap';

import {downloadJpgChart, downloadPngChart, downloadSvgChart, exportChart} from "./charts/utilities";

import {Alpine, Livewire} from '../../vendor/livewire/livewire/dist/livewire.esm';
import {registerWppUi} from '../../vendor/bernskiold/wpp-ui-blade/resources/js';
import {registerWppWysiwyg} from '../../vendor/bernskiold/wpp-ui-blade/resources/js/wysiwyg';
import Clipboard from "@ryangjchandler/alpine-clipboard";
import highchartsChart from "./charts/highchartsChart";
import '../../vendor/wire-elements/pro/resources/js/overlay-component.js';
import "flatpickr";
import AlpineFloatingUI from '@awcodes/alpine-floating-ui';
import Copy from "./alpine-components/copy";
import ChartLabels from "./alpine-components/chartLabels";
import '@wotz/livewire-sortablejs';
import translatableDescriptionList from "./alpine-components/translatable-description-list";
import listSparkline from "./alpine-components/list-sparkline";
import vantageFilterBar from "./alpine-components/vantage-filter-bar";
import editFilterValue from "./alpine-components/edit-filter-value";
import vantageComparisonSelector from "./alpine-components/vantage-comparison-selector";
import vantageUnappliedChangesGuard from "./alpine-components/vantage-unapplied-changes-guard";

/**
 * The Vantage entry point, loaded by the Vantage layouts instead of `app.js`.
 * Both import the shared modules directly and register their own Alpine
 * components; neither imports the other.
 */
window.Fount = {
    charts: {
        downloadSvg: downloadSvgChart,
        downloadJpg: downloadJpgChart,
        downloadPng: downloadPngChart,
    },
};

/**
 * Chart downloads asked for on the server, where the file name is worked out,
 * take the same path as the download buttons from here.
 */
window.addEventListener('export-chart-requested', (event) => {
    exportChart(event.detail.chartId, event.detail.type, event.detail.filename);
});

/**
 * A toast's link button, which the design system raises as an event because
 * the toast sits outside every Livewire component.
 */
window.addEventListener('wpp-notification-visit', (event) => {
    window.location.assign(event.detail.url);
});

window.addEventListener('postMessage', event => {
    window.postMessage(event.detail);
});

/**
 * Alpine
 *
 * The design system's components, and the tooltip plugin they rely on, come
 * from wpp-ui-blade.
 */
registerWppUi(Alpine);
registerWppWysiwyg(Alpine);
Alpine.plugin(Clipboard);
Alpine.plugin(AlpineFloatingUI);
Alpine.data('copy', Copy);
Alpine.data('highchartsChart', highchartsChart);
Alpine.data('chartLabels', ChartLabels);
Alpine.data('translatableDescriptionList', translatableDescriptionList);
Alpine.data('listSparkline', listSparkline);
Alpine.data('vantageFilterBar', vantageFilterBar);
Alpine.data('editFilterValue', editFilterValue);
Alpine.data('vantageComparisonSelector', vantageComparisonSelector);
Alpine.data('vantageUnappliedChangesGuard', vantageUnappliedChangesGuard);

Livewire.start();
